import * as React from 'react'
import { Button } from '@mui/material'
import { downloadJson } from '../../utility'

interface DownloadJsonButtonProps {
  data: object | string
  filename: string
  disabled?: boolean
  buttonText?: string
}

export function DownloadJsonButton({
  data,
  filename,
  disabled,
  buttonText = 'Download JSON',
}: DownloadJsonButtonProps) {
  const handleDownloadJson = () => {
    // Convert string to object if needed
    const jsonData: object =
      typeof data === 'string' ? (JSON.parse(data) as object) : data
    downloadJson(filename, jsonData)
  }

  return (
    <Button
      variant="text"
      size="small"
      onClick={handleDownloadJson}
      disabled={disabled || false}
      sx={{ textTransform: 'none', fontSize: '0.75rem' }}
    >
      {buttonText}
    </Button>
  )
}
